import { AxiosRequestConfig } from 'axios';
import { requester } from '../config';

export const listSafelocks = ({
  limit = 2 ** 30,
  start = 0,
  ...config
}: { limit?: number; start?: number } & AxiosRequestConfig = {}) =>
  requester.post('/list_safelocks', { limit, start }, config);
